export const Debt = {
    path: '/debts',
    name: 'debts',
    component: () => import('@/views/Debt/DebtPage.vue'),
    children: [
        {
            path: '/debts/add',
            name: 'debts.add',
            component: () => import('@/views/Debt/Form/DebtForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/debts/edit/:id',
            name: 'debts.edit',
            component: () => import('@/views/Debt/Form/DebtForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/debts/delete/:id',
            name: 'debts.delete',
            component: () => import('@/views/Debt/Form/DebtForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/debts/view/:id',
            name: 'debts.view',
            component: () => import('@/views/Debt/Form/DebtForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/debts/:id/refunds/add',
            name: 'debts.refunds.add',
            component: () => import('@/views/Debt/Form/RefundForm.vue'),
            props: {add_action: true}
        },
        {
            path: '/debts/:id/refunds',
            name: 'debts.refunds',
            component: () => import('@/views/Debt/RefundDetails.vue'),
        },
        {
            path: '/debts/report/debt/:id',
            name: 'debts.report',
            component: () => import('@/views/Debt/Form/ReportRefund.vue'),
        },
        {
            path: '/debts/set_decision/:id/:module',
            name: 'debts.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/debts/timelines/:id/:module',
            name: 'debts.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/debts/documents/:id',
            name: 'debts.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "DEBT"}
        },
        {
            path: '/debts/template_applications/:id',
            name: 'debts.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "DEBT"}
        },
    ]
}